<template>
  <page-table
    :sampleSetCode="sampleSetCode"
    :disabled="disabled"
    :baseInfo="baseInfo"
    @reload="$emit('reload')"
  />
</template>
<script>
import PageTable from './components/table'
export default {
  components: {
    PageTable,
  },
  props: {
    sampleSetCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    baseInfo: { type: Object, default: () => {} },
  },
}
</script>
